import { Lightning, Router } from '@lightningjs/sdk'

import { getColor, grey920 } from '../../constants/colors'
import { BORDER_RADIUS } from '../../constants/general'
import { BASE_ROUTES } from '../../constants/routes'
import { LinkModelStylesEnum } from '../../types/flo-enums'
import {
  buildPlaylistFromGrid,
  clearLockIcon,
  createSpeechTextForCards,
} from '../../utils/cardUtils'
import { ActionType, getActionType, getPaginateUrl } from '../../utils/floUtils'
import { deepCopyProperties } from '../../utils/misc'
import { captureClick, getCardPosition, SEGMENT_TRACK_EVENTS } from '../../utils/segmentAnalytics'
import { calculateRenderInfo } from '../../utils/text'
import TvCarouselContainer from '../TvCarouselContainer/TvCarouselContainer'
import TvGridContainer from '../TvGridContainer/TvGridContainer'
import SearchGrid from '../TvSearchLayout/TvSearchGrid/TvSearchGrid'
import { getCardTemplate } from './templates'
import TvBaseCard from './TvBaseCard'

export default class TvVideoCard extends TvBaseCard {
  static _template() {
    return {
      ...super._template(),
      Container: {
        w: (w) => w,
        h: (h) => h,
        rect: true,
        color: getColor(grey920),
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: BORDER_RADIUS,
        },
      },
    }
  }

  get image() {
    return this.tag('Image')
  }

  get placeholder() {
    return this.tag('Placeholder')
  }

  get title() {
    return this.tag('Title')
  }

  get speechText(): string {
    return createSpeechTextForCards(
      this.data,
      ' Select to play . ',
      this.cardIndex,
      this.totalCards,
    )
  }

  _init() {
    this.attachCardTemplate()
  }

  _active() {
    this.image.on('txLoaded', () => {
      this.placeholder.alpha = 0
      this.image.setSmooth('alpha', 1)
    })
  }

  _handleEnter() {
    void captureClick(
      SEGMENT_TRACK_EVENTS.ListItemClicked,
      this.data?.action?.analytics,
      getCardPosition(this),
    )

    const action = getActionType(this.data)

    if (action === ActionType.PLAYBACK || this.data?.action?.content_metadata) {
      let playlist = {}

      if (this.parent?.parent instanceof TvGridContainer) {
        playlist = buildPlaylistFromGrid(this.parent?.parent)
      } else if (this.parent?.parent?.parent?.parent instanceof SearchGrid) {
        playlist = buildPlaylistFromGrid(this.parent?.parent?.parent?.parent, true)
      } else if (this.parent?.parent?.parent instanceof TvCarouselContainer) {
        deepCopyProperties((this.parent?.parent?.parent as TvCarouselContainer)?.data, playlist)
      }

      Router.navigate(`${BASE_ROUTES.PLAYER}/${(<any>this.data).id}`, {
        ...this.data.action,
        subtitle: this.data?.details?.text ?? this.data.action?.content_metadata?.stream_name,
        imgUrl: this.data?.preview_image?.url,
        playlist,
      })
    } else if (
      action === ActionType.LINK &&
      this.data.action.style === LinkModelStylesEnum.Paginate
    ) {
      Router.navigate(getPaginateUrl(this.data.action.url))
    } else if (action === ActionType.LINK || !this.data.action.content_metadata) {
      const url = this.data?.action?.url
      const encodedUrl = encodeURIComponent(url)
      Router.navigate(`${BASE_ROUTES.EVENT_HUB}/${encodedUrl}`)
    } else {
      console.log('No action?!')
    }
  }

  attachCardTemplate() {
    clearLockIcon(this.data)

    this.container.patch(getCardTemplate(this.style, this.cardWidth, this.data, true))

    const truncatedTitle = this.getTruncatedTitleText()
    this.title.patch({
      text: {
        text: truncatedTitle,
      },
    })
  }

  getTruncatedTitleText() {
    const textRenderInfo = calculateRenderInfo(this.title.text, this.data?.title?.text)
    return textRenderInfo.lines.join(' ')
  }

  _handleClick() {
    this._handleEnter()
  }
}
